import { render, staticRenderFns } from "./Release530Sections.vue?vue&type=template&id=7029033e&scoped=true&"
import script from "./Release530Sections.vue?vue&type=script&lang=js&"
export * from "./Release530Sections.vue?vue&type=script&lang=js&"
import style0 from "./Release530Sections.vue?vue&type=style&index=0&id=7029033e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7029033e",
  null
  
)

export default component.exports